import StudyForm from "./StudyForm";
import { createStudy, updateDraftStudy, deleteStudy } from '../api/study';

interface StudyFormProps {
  values?: any;
}

export const StudyFormEditDraft = ({ values }: StudyFormProps) => {
  const createStudyHandler = (values: any) => {
    createStudy(values)
  }

  const draftStudyHandler = (values: any) => {
    updateDraftStudy(values)
  }

  
  const deleleStudyHandler = (values: any) => {
    deleteStudy(values?.id)
  }

  if (!values) return <></>;

  return (
    <StudyForm 
      values={values}
      createStudyHandler={createStudyHandler}
      draftStudyHandler={draftStudyHandler}
      deleteStudyHandler={deleleStudyHandler}
    />
  );
};

export default StudyFormEditDraft;